import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { resetTableState } from '../features/filterRedux/dynamicTableSlice';
import { FLOW_ROUTES } from '../constants/flowConfig';

export const useGlobalFlowCleanup = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const activeModules = useSelector(
    (state) => Object.keys(state.dynamicTables),
    shallowEqual
  );

  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();

    activeModules.forEach((moduleKey) => {
      const allowedPaths = FLOW_ROUTES[moduleKey] || [];
      const isInsideFlow = allowedPaths.some(path => currentPath.includes(path));

      if (!isInsideFlow) {
        dispatch(resetTableState({ moduleKey }));
      }
    });
  }, [location.pathname, dispatch, activeModules]); 
};